"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIOS = void 0;
var isIOS = function () {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].indexOf(navigator.platform) !== -1 ||
        // iPad on iOS 13 detection
        (navigator.userAgent.indexOf('Mac') !== -1 && 'ontouchend' in document);
};
exports.isIOS = isIOS;
//# sourceMappingURL=browserAndDeviceDetection.js.map